import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateSearchParams } from '../../SearchDatePicker/searchDatePickerSlice';
import { RootState } from '../../../store/store';
import moment from 'moment';

const useSearchParamsChanges = () => {
  const { searchParams } = useSelector((state: RootState) => state.search);
  const { siteConfig } = useSelector((data: RootState) => data.config.config);

  const dispatch = useDispatch();

  const setRooms = (rooms: string) => {
    dispatch(updateSearchParams({ ...searchParams, rooms }));
  };

  const setGuestCount = (pax: string | string[] | null) => {
    dispatch(updateSearchParams({ ...searchParams, pax }));
  };

  const setDestinationTo = (destination: string | string[] | null) => {
    dispatch(updateSearchParams({ ...searchParams, destination }));
  };

  const setDestinationFrom = (dest_f: string | null) => {
    dispatch(updateSearchParams({ ...searchParams, departure: dest_f }));
  };
  const setDestinationToCity = (destination: string | string[] | null) => {
    dispatch(
      updateSearchParams({
        ...searchParams,
        destinationCity: destination,
      })
    );
  };

  const setExtId = (extId: string | string[] | null) => {
    dispatch(
      updateSearchParams({
        ...searchParams,
        extId: extId,
      })
    );
  };


  const setEventsSearchParams = (
    extId: string | string[] | null,
    ext_type?: string | null,
    extName?: string | null
  ) => {
    dispatch(
      updateSearchParams({
        ...searchParams,
        extId: extId,
        ext_type: ext_type ?? searchParams.ext_type,
        extName: extName ?? null,
      })
    );
  };

  // const setDestinationToHotel = (hotelId: string | string[] | null) => {
  //   dispatch(
  //     updateSearchParams({ ...searchParams, destinationHotel: hotelId })
  //   );
  // };

  const setDestinationFromCity = (dest_f: string | null) => {
    dispatch(updateSearchParams({ ...searchParams, departureCity: dest_f }));
  };

  const setOneWay = (oneWay: '0' | '1') => {
    dispatch(updateSearchParams({ ...searchParams, oneWay }));
  };
  const setDirectFlight = (directFlight: '0' | '1') => {
    dispatch(updateSearchParams({ ...searchParams, directFlight }));
  };
  const setIsDpSearch = (isDpSearch: '0' | '1') => {
    dispatch(updateSearchParams({ ...searchParams, isDpSearch }));
  };

  const setDate = (date: moment.Moment | null) => {
    dispatch(
      updateSearchParams({
        ...searchParams,
        from: date?.format(siteConfig.dateFormat),
      })
    );
  };

  const setTaxonomy = (taxonomy: string[]) => {
    dispatch(updateSearchParams({ ...searchParams, taxonomy }));
  };

  const setRange = (times: [moment.Moment, moment.Moment], overrideDateKey = false) => {
    const params = {
      ...searchParams,
      from: moment(times[0]).format(siteConfig.dateFormat),
      to: times[1] ? moment(times[1]).format(siteConfig.dateFormat) : null,
    };

    if (overrideDateKey) {
      params.date = moment(times[0]).format(siteConfig.dateFormat);
    }

    dispatch(
      updateSearchParams(params)
    );
  };

  const setDateFrom = (times: moment.Moment) => {
    dispatch(
      updateSearchParams({
        ...searchParams,
        from: times.format(siteConfig.dateFormat),
      })
    );
  };

  const setDateTo = (times: moment.Moment) => {
    dispatch(
      updateSearchParams({
        ...searchParams,
        to: times.format(siteConfig.dateFormat),
      })
    );
  };

  const setMfeature = (mfeature: string | null) => {
    dispatch(
      updateSearchParams({
        ...searchParams,
        mfeature: mfeature,
        destination: '',
      })
    );
  };

  return {
    setDateTo,
    setDateFrom,
    setRooms,
    setGuestCount,
    setDestinationTo,
    setDestinationFrom,
    setOneWay,
    setRange,
    setDate,
    setDestinationFromCity,
    setDestinationToCity,
    setExtId,
    setDirectFlight,
    setIsDpSearch,
    setTaxonomy,
    setMfeature,
    setEventsSearchParams,
    // setDestinationToHotel,
  };
};

export default useSearchParamsChanges;
